import { Injectable } from '@angular/core';

import { LOCAL_STORAGE_KEY } from '../../common/constants';

interface CalendarPreferences {
  view: string;
  type: string;
}

export const defaults = {
  calendar: {
    type: 'all',
    view: 'day',
  },
};

@Injectable()
export class AppPreferenceService {
  constructor() {}

  getCalendarPreferences(): CalendarPreferences {
    const localStorageValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.PREFERENCES.CALENDAR));

    return {
      ...defaults.calendar,
      ...localStorageValue,
    };
  }

  setCalendarPreferences(preferences: CalendarPreferences): void {
    const value = JSON.stringify({
      ...defaults.calendar,
      ...preferences,
    });

    return localStorage.setItem(LOCAL_STORAGE_KEY.PREFERENCES.CALENDAR, value);
  }
}
